import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { signIn } from "aws-amplify/auth";

import Button from '@mui/material/Button';

import Validate from "../utility/FormValidation";
import { Box, Paper, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import bgImage from '../../background/bgd_login.jpg'

import Link from '@mui/material/Link';

import logo from './../../logos/Logo_Cerchio_1000px.svg'
import LoginImage from '../../background/logInImage_00.jpg'

export default function Login({ auth }) {

    const [credentialsForm, setCredentialsForm] = useState({
        username: '',
        password: '',
        showPassword: false,
        isLogging: false,
        errors: {
            username: "",
            password: "",
            cognito: ""
        },
    });

    const history = useHistory();
    const redirect = (dst) => {
        history.push(dst);
    }

    const handleSubmit = async () => {
        setCredentialsForm({ ...credentialsForm, isLogging: true });

        try {
            const { isSignedIn, nextStep } = await signIn({
                username: credentialsForm.username,
                password: credentialsForm.password
            });

            if (isSignedIn) {
                console.log("Login successful");
                await auth.refreshAuthentication();
                setCredentialsForm({ ...credentialsForm, isLogging: false });
                const location = !sessionStorage.getItem("manualLogout") ? (sessionStorage.getItem("redirect") || "/dashboard") : "/dashboard"
                sessionStorage.removeItem("redirect")
                sessionStorage.removeItem("manualLogout")
                redirect(location);
            }
        } catch (error) {
            localStorage.clear();
            // console.log("error", JSON.stringify(error));
            setCredentialsForm({
                ...credentialsForm,
                errors: {
                    ...credentialsForm.errors,
                    cognito: error.message || 'Unexpected error during authentication',
                },
                isLogging: false
            });
        }
    };


    const onInputChange = event => {
        const error = Validate({ ...credentialsForm, [event.target.id]: event.target.value });
        setCredentialsForm({
            ...credentialsForm,
            [event.target.id]: event.target.value,
            errors: { ...credentialsForm.errors, ...error, cognito: null }
        });

    }

    const handleClickShowPassword = () => {
        setCredentialsForm({
            ...credentialsForm,
            showPassword: !credentialsForm.showPassword,
        });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleEnterKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSubmit()
        }
    }


    return (

        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                overflow: 'hidden',
                height: '100vh',
                width: '100%',
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            id='bg-container'
        >
            <Paper
                sx={{
                    width: { xs: '90%', md: '70%' }, // più largo su desktop
                    minWidth: '23em',
                    maxWidth: '60em',
                    m: 'auto',
                    marginTop: '8em',
                    padding: 0,
                    display: 'flex',
                    height: { xs: 'auto', md: '60%' }, // altezza adattiva su mobile
                    overflow: 'hidden'
                }}
                elevation={3}
            >
                {/* Colonna sinistra con immagine extra - visibile solo su desktop */}
                <Box
                    sx={{
                        width: '55%',
                        backgroundImage: `url(${LoginImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: { xs: 'none', md: 'block' } // nascondi su mobile
                    }}
                />

                {/* Colonna destra con login */}
                <Box
                    sx={{
                        width: { xs: '100%', md: '45%' }, // occupa tutto lo spazio su mobile
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '2em',
                        backgroundColor: 'white',
                    }}
                >
                    <Stack
                        direction="column"
                        spacing={2}
                        alignItems="center"
                        noValidate
                        autoComplete="off"
                        sx={{ width: '100%' }}
                    >
                        <img src={logo} height="80" alt="pagination logo" />

                        <Typography variant='h1' sx={{ fontSize: '2em', fontWeight: 'bold', color: '#515151' }}>
                            Welcome!
                        </Typography>

                        <TextField
                            label="email"
                            id="username"
                            value={credentialsForm.username}
                            onChange={onInputChange}
                            error={credentialsForm.errors.username !== ""}
                            helperText={credentialsForm.errors.username ? credentialsForm.errors.username : ''}
                            sx={{ width: '100%' }}
                            onKeyDown={handleEnterKeyDown}
                        />

                        <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                            <InputLabel error={credentialsForm.errors.password !== ""}>Password</InputLabel>
                            <OutlinedInput
                                id="password"
                                label="password"
                                type={credentialsForm.showPassword ? 'text' : 'password'}
                                value={credentialsForm.password}
                                onChange={onInputChange}
                                error={credentialsForm.errors.password !== ""}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {credentialsForm.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                onKeyDown={handleEnterKeyDown}
                            />
                            {credentialsForm.errors.password !== "" &&
                                <FormHelperText error id="pass-err">
                                    {credentialsForm.errors.password}
                                </FormHelperText>
                            }
                        </FormControl>

                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                            <Link underline="hover" onClick={() => redirect('/forgotpassword')} sx={{ marginTop: '1em', color: '#515151', cursor: 'pointer' }}>
                                Forgot password?
                            </Link>
                        </Box>

                        {credentialsForm.errors.cognito !== undefined &&
                            <Typography variant='caption' color='error'>
                                {credentialsForm.errors.cognito}
                            </Typography>
                        }

                        <Button
                            color="primary"
                            disabled={credentialsForm.errors.username !== '' || credentialsForm.errors.password !== ''}
                            loading={credentialsForm.isLogging}
                            variant="contained"
                            onClick={handleSubmit}
                            sx={{ marginTop: '1em', width: '7em' }}
                        >
                            Login
                        </Button>
                    </Stack>
                </Box>
            </Paper>
        </Box>





    )

}
